// import React, { useState, useEffect } from 'react';

// const Flowerfetch = ({jzgbh}) => {
//     const [flower_co, setFlower_co] = useState([]);

//     useEffect(() => {
//         let isMounted = true; 
    
//         fetch(`http://localhost:5000/api/Teacher_Papers?JZGBH=${jzgbh}`) 
//             .then(response => {
//                 if (!response.ok) {
//                     throw new Error('Network response was not ok');
//                 }
//                 return response.json();
//             })
//             .then(flowerData => {
//                 if (isMounted) { 
//                     setFlower_co(flowerData);
//                 }
//             })
//             .catch(error => {
//                 console.error('Fetching error:', error);
//             });
    
//         return () => {
//             isMounted = false;
//         };
//     }, [jzgbh]);

//     return flower_co;
// }

// export default Flowerfetch;

// flowerFetch.js

// export async function Flowerfetch(jzgbh) {
//     try {
//       const response = await fetch(`http://localhost:5000/api/Teacher_Papers?JZGBH=${jzgbh}`);
//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.status}`);
//       }
//       const data = await response.json();
//       return data;
//     } catch (error) {
//       console.error('Fetching error:', error);
//       throw error; // 可以抛出错误，让调用者处理
//     }
//   }
export function Flowerfetch(jzgbh, callback) {
    fetch(`https://dandeline.tongji.edu.cn/api/Teacher_dandelion?JZGBH=${jzgbh}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        callback(data); // 调用回调函数，没有错误，传入数据
      })
      .catch(error => {
        callback(null); // 调用回调函数，传入错误对象，数据为null
      });
  }
  